import { Button, FileButton } from "@mantine/core";
import { useController, useFormContext } from "react-hook-form";
import { Flex } from "src/styled";
import { fileToBase64, openBase64 } from "src/utils";

interface Props {
  id: string;
  filename: string;
  filetype: string;
  b64: string;
  deleteAvailable?: boolean;
  title?: string;
}

const FileAttachment = ({
  id,
  filename,
  filetype,
  b64,
  deleteAvailable,
  title,
}: Props) => {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({
    name: id + ".attachment",
    control,
    defaultValue: { filename, b64, filetype },
  });

  const handleSetFile = async (file: File) => {
    const filename = file.name;
    const filetype = file.type === "application/pdf" ? "pdf" : "jpg";
    const b64 = await fileToBase64(file);
    onChange({ filename, filetype, b64, type: "attachment" });
  };

  const handleOpenFile = () => {
    openBase64(value.b64, value.filetype, value.filename, false);
  };
  const handleDeleteFile = () => {
    onChange({ filename: "", filetype: "", b64: "" });
  };
  if (!value.b64) {
    return (
      <FileButton
        onChange={handleSetFile}
        accept="image/png,image/jpeg,application/pdf">
        {props => (
          <Button w="min-content" variant="outline" {...props}>
            {title ?? "Upload File"}
          </Button>
        )}
      </FileButton>
    );
  }

  return (
    <Flex gap={5}>
      <Button w="min-content" onClick={handleOpenFile}>
        {value.filename}
      </Button>
      {deleteAvailable && (
        <Button
          w="min-content"
          onClick={handleDeleteFile}
          variant="outline"
          color="red">
          Delete File
        </Button>
      )}
    </Flex>
  );
};

export default FileAttachment;
